import { render } from "./GifT.vue?vue&type=template&id=1318c2c7"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/GifT.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1318c2c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1318c2c7', __exports__)) {
    api.reload('1318c2c7', __exports__)
  }
  
  module.hot.accept("./GifT.vue?vue&type=template&id=1318c2c7", () => {
    api.rerender('1318c2c7', render)
  })

}


export default __exports__